import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "trayek-form" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs" }, "Pilih Kelas:", -1)
const _hoisted_3 = { class: "mt-2" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Pilih")

import { PropType, computed, ref } from 'vue'
import SelectAsync from '@/views/components/form/SelectAsync.vue'
import Button from 'primevue/button'


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterClass',
  props: {
  selected: {
    default: null as any
  }
},
  emits: ["selectSearchOption"],
  setup(__props, { emit }: { emit: ({
  (e: 'selectSearchOption', evt: any, val: any): void
}), expose: any, slots: any, attrs: any }) {

const props = __props





const selectedClass = ref(props.selected) as any

const submit = (evt: any) => {
  // console.log('selectedClass', selectedClass.value)
  emit('selectSearchOption', evt, selectedClass.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(SelectAsync, {
      endpoint: "/management/v1/MsClass",
      classname: "custom-select",
      searchCustom: [['activeOnly', '=', 'true']],
      fieldLabel: (v) => v.Name,
      searchFields: ['name'],
      placeholder: 'Semua Kelas',
      modelValue: _unref(selectedClass),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(selectedClass) ? (selectedClass).value = $event : null))
    }, null, 8, ["fieldLabel", "modelValue"]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(Button), {
        class: "btn-primary w-full mt-5",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (submit($event)))
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      })
    ])
  ]))
}
}

})